import { render, staticRenderFns } from "./ScrollyMapChapterLegend.vue?vue&type=template&id=f5e58d50&scoped=true&"
import script from "./ScrollyMapChapterLegend.vue?vue&type=script&lang=js&"
export * from "./ScrollyMapChapterLegend.vue?vue&type=script&lang=js&"
import style0 from "./ScrollyMapChapterLegend.vue?vue&type=style&index=0&id=f5e58d50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5e58d50",
  null
  
)

export default component.exports